import { Box, BoxProps } from "@chakra-ui/react"
import { useEffect, useRef } from "react"

type Props = {
  id: string
  autoplay: boolean
  backgroundMode: boolean
  muted: boolean
  containerStyles?: BoxProps
}

const TrailerDailymotion = ({
  id,
  autoplay,
  backgroundMode,
  muted,
  containerStyles
}: Props) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!ref.current) return
    const params = new URLSearchParams({
      autoplay: autoplay ? "1" : "0",
      mute: backgroundMode ? "1" : "0",
      controls: backgroundMode ? "0" : "1",
      "ui-logo": "0",
      "ui-start-screen-info": "0",
      "sharing-enable": "0",
      "queue-enable": "0",
      "endscreen-enable": "0",
      loop: backgroundMode ? "1" : "0",
      api: "1",
      origin: typeof window !== "undefined" ? window.location.origin : ""
    })
    const html = `<iframe width=\"100%\" height=\"100%\" src=\"https://www.dailymotion.com/embed/video/${id}?${params.toString()}\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture\" allowfullscreen></iframe>`
    ref.current.innerHTML = html
  }, [id, autoplay, backgroundMode])

  useEffect(() => {
    const iframe = ref.current?.querySelector(
      "iframe"
    ) as HTMLIFrameElement | null
    if (!iframe) return
    try {
      const dmTarget = "https://www.dailymotion.com"
      iframe.contentWindow?.postMessage(
        JSON.stringify({ command: muted ? "mute" : "unmute" }),
        dmTarget
      )
      if (!backgroundMode && !muted) {
        iframe.contentWindow?.postMessage(
          JSON.stringify({ command: "play" }),
          dmTarget
        )
      }
    } catch (_) {}
  }, [muted, backgroundMode])

  return (
    <Box
      ref={ref}
      position="relative"
      css={{
        aspectRatio: "16/9",
        "& iframe": { width: "100%", height: "100%", border: "none" }
      }}
      {...containerStyles}
    />
  )
}

export default TrailerDailymotion
